module.exports = __webpack_public_path__ + "static/media/3-1@2x.ad66030c.png";